import releaseNotesData from './releaseNotes.json';

export type ReleaseNoteItemType = 'feature' | 'improvement' | 'fix';

export interface ReleaseNoteItem {
  type: ReleaseNoteItemType;
  /** Kundentauglicher Text auf Deutsch. Andere Sprachen zeigen denselben Text. */
  text: string;
  /**
   * Optionale, ausklappbare Erklärung: wo die Funktion zu finden ist und wie sie
   * bedient wird. Ein Absatz je Eintrag; ohne Markdown.
   */
  details?: string[];
}

export interface ReleaseNote {
  /** Semver, z. B. "1.1.0". Der oberste Eintrag ist die aktuelle App-Version. */
  version: string;
  /** ISO-Datum (YYYY-MM-DD) des Releases. */
  date: string;
  title: string;
  items: ReleaseNoteItem[];
}

// Die JSON-Datei ist die einzige Wahrheitsquelle für die App-Version — sie wird
// auch von vite.config.ts gelesen, um __APP_VERSION__ und dist/version.json zu füllen.
export const releaseNotes = releaseNotesData as ReleaseNote[];

export const LATEST_VERSION = releaseNotes[0]?.version ?? '0.0.0';

function parseVersion(version: string): number[] {
  return version.split('.').map((part) => Number.parseInt(part, 10) || 0);
}

/** true, wenn `version` semver-mäßig neuer ist als `other`. */
export function isNewerVersion(version: string, other: string): boolean {
  const a = parseVersion(version);
  const b = parseVersion(other);
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const diff = (a[i] ?? 0) - (b[i] ?? 0);
    if (diff !== 0) return diff > 0;
  }
  return false;
}
